// utils/navigationHelper.js
import { route_tab, routerLogin } from "./pageRoute";

export const getDefaultRouteByAccess = (tabList = []) => {
   
  if (!Array.isArray(tabList) || tabList.length === 0) return false;

  // Normalize tab list (handle both array of objects or strings)
  const accessList = tabList.map((t) => (typeof t === "object" ? t.tab : t));

  for (const module of route_tab) {
    if (accessList.includes(module)) {
      const moduleLinks = routerLogin[module];
      if (moduleLinks && moduleLinks.length > 0) {
        return moduleLinks[0].link;
      }
    }
  }

  return false;
};
